export const API_PREFIX = 'api/v1/';

export default {
  RECORDS_LIMIT: {
    table: 50,
    cards: 1000,
    calendar: 250,
    pivot: 10000,
    count: Infinity,
    gantt: 10000,
  },
};
